<div class="container">
    <header class="row">
        <div class="col-12">
            <h3 class="text-center accent-font-color-mid">{{ 'privacy-policy.privacy-policy' | translate }}</h3>
        </div>
    </header>
    <section class="row justify-content-center mt-3">
        <div class="col-12">
            <ng-container *ngTemplateOutlet="currentLang === 'en' ? enTemplate: deTemplate"></ng-container>
        </div>
    </section>
</div>

<!-- Text template for German  -->
<ng-template #deTemplate>
    <h5>
        Information über die Erhebung personenbezogener Daten
    </h5>
    <p class="mt-4">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
        dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
        clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
        consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
        diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
        takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
</ng-template>

<!-- Text template for English  -->
<ng-template #enTemplate>
    <h5>
        Information über die Erhebung personenbezogener Daten
    </h5>
    <p class="mt-4">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
        dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
        clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
        consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
        diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
        takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
</ng-template>
